import Details from 'components/Details'
import { BtnDesc } from 'components/form'
import I from 'components/I'
import { Alert, Form, ListGroup } from 'react-bootstrap'
import { Trans, useTranslation } from 'react-i18next'
import platform from 'utils/platform'

export default function TextSize() {
	const { t } = useTranslation()

	//TODO the biggest blocker from using bigger font sizes (and that should be fixed so they adjust better to larger values) are:
	// - the Menu Items list and Form, which don't reduce the column count
	// - then, the sidebar which should hide (which hinders the Orders List in landscape)
	// - on Android, titles usually get cut and icons don't resize as expected. Otherwise, larger fonts usually work.
	const EXPLANATIONS = {
		[platform.IOS]:
			<Trans>
				<p>This is controlled by your device's own settings. If you are unsure how to configure that, visit <a href="https://support.apple.com/HT202828">this Apple Support page</a>.</p>
				<p>Starting on iOS 15, it's also possible to change the text size for individual apps: <a href="https://support.apple.com/guide/ipad/per-app-settings-ipad723b5a33/ipados">here's how</a>.</p>
				<p>You will need to close and reopen the Manager app for changes to take effect.<b></b></p>
			</Trans>,
		[platform.ANDROID]: <Trans>
			<p>This is controlled by your device's own settings. If you are unsure how to configure that, visit <a href="https://support.google.com/accessibility/android/answer/11183305">this Android Help page</a>. Try to change the <I q>Display size / Screen zoom</I> before changing <I q>Font size</I>, since that works better with our app.</p>
			<p>Note that some of those steps or sections may be slight different, depending on the manufacturer of your device. If you can't find those options, you can try using the Settings search or checking <a href="https://support.google.com/android/answer/3094742">the manufacturer guides</a>.</p>
		</Trans>,
		computer: <Trans>
			<p>On web browsers, all you need to do is change the <I q>display Zoom</I>. This is usually achieved via:</p>
			<ul className="mb-3">
				<li><kbd>Ctrl/⌘</kbd> + <kbd>+</kbd> or <kbd>-</kbd></li>
				<li><kbd>Ctrl/⌘</kbd> + <kbd>mouse scroll</kbd></li>
				<li>Edge or Chrome: <BtnDesc icon="ellipsis-v"/> (top/right) > <I en>Zoom</I> <kbd>+</kbd> or <kbd>-</kbd></li>
				<li>Mac's Safari: <I en>Safari > Settings for Manager > Page Zoom > View > Zoom in</I></li> {/* TODO double check "make only text larger" https://is.gd/94r9zc */}
			</ul>
		</Trans>,
		mobileWeb: <Trans>
			<p>On mobile browsers, all you need to do is change the <I q>text scaling</I>, as follows:</p>
			<ul className="mb-3">
				<li>Android's Chrome/Firefox: <I en><BtnDesc icon="ellipsis-v"/> > Settings > Accessibility > Text scaling / Font Size</I></li>
				<li>iOS's Safari: <kbd style={{fontVariant: 'small-caps'}}>aA</kbd> button to the left of the address field > change zoom in the first line of that menu</li>
			</ul>
		</Trans>,
		[false]: <>
			<p><Trans>Unfortunately, we couldn't identify the platform you're using. Usually, look for your phone/tablet's Settings, under <I q>Display > Font Size</I> or <I q>Zoom</I>. Otherwise, if you're on a web browser, look for zoom options.</Trans></p>
			<p>{t('CONTACT_FURTHER_HELP')}</p>
		</>
	}

	let explanation = EXPLANATIONS[
		platform.isIOS()? platform.IOS :
			platform.isAndroid()? platform.ANDROID :
				platform.isWeb()? (platform.isMobile()? 'mobileWeb' : 'computer') :
					false
	]

	// explanation = EXPLANATIONS[platform.IOS]
	// explanation = EXPLANATIONS[platform.ANDROID]
	// explanation = EXPLANATIONS.computer
	// explanation = EXPLANATIONS.mobileWeb
	// explanation = EXPLANATIONS[false]

	return <ListGroup.Item>
		<Form.Label>{t('Text/font size:')}</Form.Label>
		<Details actionTxts={[t('Check here how to configure font sizes'), t('Close this information')]}>
			{explanation}
			<Alert variant="info">
				<Trans><b>Note:</b> making the text size too big may cause issues with the app. If something seems out of place or not visible after changing the sizes, try reducing it a bit.</Trans>
			</Alert>
		</Details>
	</ListGroup.Item>
}
